export default __webpack_public_path__ + "static/niepolomice-image1-849bbf34fce0e51a9b7573f0252de7ab.jpg";